<script setup>
// import { ref } from 'vue';
import VehicleTable from "./Tables/VehicleTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Vehicle</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Vehicle No</label>
                            <input class="form-control" v-model="model.vehicle.vehicleno" id="input_lorry_no" type="text" placeholder="KCB 8028" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Type</label>
                            <select class="form-control" v-model="model.vehicle.type" @change="showPuspakom">
                                <option value="0">Car</option>
                                <option value="1">Lorry</option>
                                <option value="2">Motor</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Active</label>
                            <select class="form-control" v-model="model.vehicle.isexpired" >
                                <option value="0">Active</option>
                                <option value="1">Expired</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.vehicle.remark"  placeholder="Remark...." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Insurance</label>
                            <input type="date" id="input_date" v-model="model.vehicle.insurance" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Roadtax</label>
                            <input type="date" id="input_date" v-model="model.vehicle.roadtax" class="form-control" >
                        </div>
                        <div class="col-md-3" v-show="vPuspakom">
                            <label for="example-text-input" class="form-control-label text-danger">Puspakom</label>
                            <input type="date" id="input_date" v-model="model.vehicle.puspakom" class="form-control" >
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addVehicle" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <VehicleTable :key="componentKey" />
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'vehicleCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
      model:{
        vehicle:{
            vehicleno:'',
            type:'1',
            puspakom: new Date().toISOString().slice(0,10),
            insurance: new Date().toISOString().slice(0,10),
            roadtax: new Date().toISOString().slice(0,10),
            remark:'',
            isexpired:'0'
        }
      },
      vPuspakom:true,
    }
  },
  methods: {
    showPuspakom(){
        if(this.model.vehicle.type == 1){
            this.vPuspakom = true;
        }else{
            this.vPuspakom = false;
        }
    },
    addVehicle(){
        console.log(this.model.vehicle);
        // var mythis = this;
        axios.post('vehicle/addVehicle',this.model.vehicle)
            .then(res => {
                alert(res.data.message);
                this.model.vehicle = {
                    vehicleno:'',
                    type:'1',
                    puspakom:'',
                    insurance:'',
                    roadtax:'',
                    remark:'',
                    isexpired:'0'
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>
